import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { NotFound } from "./utils/notFound";
import { NavBar } from "./components/navigation/navBar";
import { LandingPage } from "./pages/LandingPage";
import { PropertyPage } from "./pages/PropertyPage";
import { ListProperties } from "./pages/ListProperties";
import ScrollToTop from "./utils/ScrollToTop";

const SITE_ACCESS_BLOCKED = true;

function App() {
  if (SITE_ACCESS_BLOCKED) {
    return (
      <main className="site-blocked">
        <section className="site-blocked__content" aria-labelledby="site-blocked-title">
          <p className="site-blocked__label">Notice</p>
          <h1 id="site-blocked-title">This service or website is no longer available</h1>
          <p>Thanks.</p>
        </section>
      </main>
    );
  }

  return (
    <Router>
      <NavBar />
      <ScrollToTop>
        <Routes>
          <Route exact path="/" element={<LandingPage />} />
          <Route exact path="/all" element={<ListProperties />} />
          <Route exact path="id/:propertyId" element={<PropertyPage />} />
          <Route exact path="/*" element={<NotFound />} />
        </Routes>
      </ScrollToTop>
    </Router>
  );
}

export default App;
